import { render, staticRenderFns } from "./company-details-contacts-container.vue?vue&type=template&id=fc8a50fc&scoped=true&lang=pug"
import script from "./company-details-contacts-container.vue?vue&type=script&lang=ts"
export * from "./company-details-contacts-container.vue?vue&type=script&lang=ts"
import style0 from "./company-details-contacts-container.vue?vue&type=style&index=0&id=fc8a50fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8a50fc",
  null
  
)

export default component.exports